module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_115-896c22da2cda5c2c664047a3d6274fb2.png";